export const color = {
    primary: "#F0E4CF",
    secondary: "#0E1921",
    secondaryLight: "#1A2B37",
    black: "#0A0A0B",
    white: "#F8F7FF",
    whiteShade: "#A8ABB4",
    bg:"#0A141B",
}